import React, { useState } from "react";
import { useLoadScript } from "@react-google-maps/api";
import { useUserRole } from "../../../context/UserRoleContext";
import DashboardLayout from "../../../components/common/DashboardLayout";
import BarList from "../../bar-owner/components/management/BarList";
import ArtistsByBar from "../../bar-owner/components/management/ArtistsByBar";

const libraries = ["places"];

const Management = () => {
  const { loading } = useUserRole();
  const [activeTab, setActiveTab] = useState("bars");

  const { isLoaded: isMapsLoaded } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "",
    libraries,
  });

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner">Loading...</div>
      </div>
    );
  }

  const tabs = [
    { id: "bars", label: "Bar Information", icon: "🏪" },
    { id: "artists", label: "Artists", icon: "🎤" },
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case "bars":
        return (
          <BarList
            isMapsLoaded={isMapsLoaded}
            allowAddBar={false}
            emptyStateRole="admin"
          />
        );
      case "artists":
        return (
          <div className="management-content">
            <div className="management-section">
              <ArtistsByBar isMapsLoaded={isMapsLoaded} />
            </div>
          </div>
        );
      default:
        return (
          <BarList
            isMapsLoaded={isMapsLoaded}
            allowAddBar={false}
            emptyStateRole="admin"
          />
        );
    }
  };

  return (
    <DashboardLayout>
      <div className="bar-owner-dashboard">
        <div className="tab-selector">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              className={`tab-button ${activeTab === tab.id ? "active" : ""}`}
              onClick={() => setActiveTab(tab.id)}
            >
              <span className="tab-icon">{tab.icon}</span>
              <span className="tab-label">{tab.label}</span>
            </button>
          ))}
        </div>

        <div className="tab-content">{renderTabContent()}</div>
      </div>
    </DashboardLayout>
  );
};

export default Management;
